import React from 'react';

const DashboardIcon = () => {
    return (
        <svg width={25} height={25} viewBox="0 0 25 25">
            <g transform="translate(-1 -1)">
                <circle
                    cx={11.5}
                    cy={11.5}
                    r={11.5}
                    transform="translate(2 2)"
                    fill="none"
                    stroke="#8F99DC"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                />
                <path
                    d="M10.154 10.049a3.45 3.45 0 016.7 1.15c0 2.3-3.45 3.45-3.45 3.45M13.5 19.25h.012"
                    fill="none"
                    stroke="#8F99DC"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                />
            </g>
        </svg>
    );
};

export default DashboardIcon;
